export const BLOG_POSTS = [
    {
        id: 1,
        slug: 'benefits-of-toy-trading-for-parents',
        title: 'The Hidden Benefits of Toy Trading for Pakistani Parents',
        excerpt: 'Discover how trading toys can save you money, reduce clutter, and teach your children valuable lessons about sustainability.',
        content: `
            <p>Parenting in Pakistan comes with its own set of challenges, especially when it comes to managing the ever-growing pile of toys. Children grow out of toys faster than we can buy them. This is where <strong>ToyTrade.pk</strong> comes in.</p>
            
            <h3>1. Cost Savings</h3>
            <p>Quality toys like LEGO, Fisher-Price, or Hot Wheels can be expensive. By trading toys your child no longer plays with, you can get "new" ones without spending a rupee.</p>
            
            <h3>2. Clutter Reduction</h3>
            <p>Every parent knows the struggle of a room overflowing with toys. Trading allows you to keep the toy box fresh while ensuring that old toys don't end up in a landfill.</p>
            
            <h3>3. Teaching Sustainability</h3>
            <p>In a world focused on consumption, toy trading is a practical way to teach children about the circular economy and the importance of reusing items.</p>
            
            <p>Start your trading journey today on the ToyTrade app!</p>
        `,
        image: '/images/blog/blog1.jpg',
        date: '2025-12-21',
        author: 'ToyTrade Team',
        tags: ['Parenting', 'Toys', 'Pakistan', 'Sustainability']
    },
    {
        id: 2,
        slug: 'top-toys-for-teenagers-in-pakistan',
        title: 'Top 5 Trending Toys and Collectibles for Teenagers in Pakistan',
        excerpt: 'From action figures to board games, see what teenagers in Pakistan are trading this season.',
        content: `
            <p>Toy trading isn't just for toddlers! We've seen a massive surge in teenagers using ToyTrade.pk to swap collectibles and high-end gadgets.</p>
            
            <h3>1. Action Figures & Funko Pops</h3>
            <p>Marvel, DC, and Anime figures are highly sought after. Trading these allows collectors to complete their sets without breaking the bank.</p>
            
            <h3>2. Retro Gaming Consoles</h3>
            <p>Old GameBoys and PlayStation Move controllers are making a comeback. Teenagers are increasingly looking for vintage tech.</p>
            
            <h3>3. Strategy Board Games</h3>
            <p>Games like Catan and Risk are popular in major cities like Karachi and Lahore. Trading these expensive boxes is a great way to try new games.</p>
            
            <p>Join the community and find your next collectible today!</p>
        `,
        image: '/images/blog/blog2.jpg',
        date: '2025-12-20',
        author: 'Collectibles Expert',
        tags: ['Teenagers', 'Collectibles', 'Gaming', 'Pakistan']
    }
];
